import React from 'react'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const CardContainer = styled(Card)`
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
  text-align: center;
  font-size: 1.125em;
`

const IconContainer = styled.span`
  display: inline-block;
  width: 2.5em;
  height: 2.5em;
  border-radius: 50%;
  background-color: #f1f1f1;
  text-align: center;
  line-height: 2.625em;
`
const CardIcon = styled.div`
  text-align: center;
`
const CardTitle = styled.h2`
  font-weight: normal;
`
export default function LogCard(props) {
  const { text, number, icon, textType } = props
  return (
    <Col className="md-3 px-2 mb-2">
      <CardContainer className="h-100">
        <Card.Body>
          <CardIcon className={`${textType} mb-3`}>
            <IconContainer>
              <FontAwesomeIcon icon={icon} className="fa-lg" />
            </IconContainer>
          </CardIcon>
          <CardTitle>{number}</CardTitle>
          <Card.Text>{text}</Card.Text>
        </Card.Body>
      </CardContainer>
    </Col>
  )
}

LogCard.propTypes = {
  text: PropTypes.string,
  number: PropTypes.number,
  icon: PropTypes.object,
  textType: PropTypes.string,
}
